import React from 'react';
import { useTranslation } from 'react-i18next';
import { Sparkles } from 'lucide-react';

/**
 * FoundingBusinessBadge — small elegant tag shown on cards / profiles for
 * businesses on the Founding Business Offer (`subscriptionPlan === "founders"`).
 *
 * Renders nothing for any other plan. Two size variants:
 *   - "card" (default): tiny chip suitable for listing thumbnails
 *   - "profile": slightly bigger pill suitable for the business detail header
 *
 * Goal: increase perceived value / social proof for early businesses, without
 * dominating the layout.
 */
const FoundingBusinessBadge = ({ plan, variant = 'card' }) => {
  const { t } = useTranslation();
  if (plan !== 'founders') return null;

  const isProfile = variant === 'profile';
  const base = 'inline-flex items-center gap-1 font-semibold rounded-full bg-gradient-to-r from-amber-400 to-orange-400 text-white shadow-sm';
  const sizing = isProfile
    ? 'px-2.5 py-1 text-xs'
    : 'px-1.5 py-0.5 text-[10px]';
  const iconSize = isProfile ? 'h-3 w-3' : 'h-2.5 w-2.5';

  return (
    <span
      className={`${base} ${sizing}`}
      data-testid={`founding-badge-${variant}`}
      title={t('foundingBadge.tooltip', 'One of the founding businesses on Find-2-Day')}
    >
      <Sparkles className={iconSize} aria-hidden="true" />
      {t('foundingBadge.label', 'Founding Business')}
    </span>
  );
};

export default FoundingBusinessBadge;
